export enum EmergencyAccessType {
  View = 0,
  Takeover = 1,
}
